(function($) {


    // Scrollto link

    $(".scrollto").bind("click",function(e){

        var
            href = $(this).attr( 'href' ),
            html = $('html, body');

        html.animate({scrollTop: $(href).offset().top});

        e.preventDefault();

    });

    // Resources

    if ($(".m-document__subnav").length) {

        var subnavTop = $(".m-document__subnav").offset().top; // get initial position of the element

        $(window).scroll(function() {

            var currentScroll = $(window).scrollTop();

            if (currentScroll >= subnavTop) {
                $('.m-document__subnav').addClass("m-document__subnav--fixed");
            } else {
                $('.m-document__subnav').removeClass("m-document__subnav--fixed");
            }

        });

    }


})(jQuery);